'use strict';

const getUserPage = () => {
	localStorage.setItem('_b9_user_last_page', window.location.href );
};

export default function () {
	document.addEventListener('DOMContentLoaded', getUserPage);
}
